import _ from "lodash-es";
import axios, { CancelTokenSource } from "axios";
import vue from "@/main";
import gateway from "@/lib/request/gateway";

export default interface CKEDITOR {
  ClassicEditor: ClassicEditor;
  InlineEditor: InlineEditor;
}

export interface Editor {
  model: Model;
  plugins: PluginCollection;
  create(element: HTMLElement, config: object): Promise<Editor>;
  getData(): string;
  setData(value: string): void;
  destroy(): void;
  execute(commandName: string, value: string): void;
}
export interface ClassicEditor extends Editor {
  create(element: HTMLElement, config: object): Promise<ClassicEditor>;
}
export interface InlineEditor extends Editor {
  create(element: HTMLElement, config: object): Promise<InlineEditor>;
}

export interface Model {
  document: Document;
  change(callback: (writer: Writer) => void): void;
}

export interface Writer {
  insertText(s: string, itemOrPosition: Position, offset?: number): void;
  insertText(
    s: string,
    attributes: object,
    itemOrPosition: Position,
    offset?: number
  ): void;
  insert(item: unknown, itemOrPosition: Position, offset?: number): void;
}

export interface Document {
  selection: DocumentSelection;
  on(event: string, callback: () => void): void;
}

export interface DocumentSelection {
  getFirstPosition(): Position;
}

export interface Position {
  index: number;
}

export interface PluginCollection {
  get(key: string): PluginInterface;
}

export interface PluginInterface {
  pluginName: string;
  isContextPlugin: boolean;
}

export interface UploadLoader {
  id: string;
  status: string;
  uploadTotal: number | null;
  uploaded: number;
  uploadedPercent: number;
  file: Promise<File>;
}

export class ImageUploadAdapter {
  loader: UploadLoader;
  cancelTokenSource: CancelTokenSource;
  constructor(loader: UploadLoader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
    this.cancelTokenSource = axios.CancelToken.source();
  }

  // Starts the upload process.
  upload() {
    // Update the loader's progress.
    /*
    server.onUploadProgress((data: any) => {
      loader.uploadTotal = data.total;
      loader.uploaded = data.uploaded;
    });
    */
    // Return a promise that will be resolved when the file is uploaded.
    return this.loader.file.then((file: File) => {
      return gateway
        .anonymousGetPostPolicy(file.name)
        .then(postPoilcy => {
          return gateway.upload(postPoilcy, file, {
            cancelToken: this.cancelTokenSource.token,
            onUploadProgress: (progressEvent: any) => {
              if (progressEvent.lengthComputable) {
                this.loader.uploadTotal = progressEvent.total;
                this.loader.uploaded = progressEvent.loaded;
              }
            }
          });
        })
        .then(uploaded => {
          return {
            default: uploaded.url
          };
        })
        .catch(err => {
          vue.$message.error(String(err));
        });
    });
  }

  // Aborts the upload process.
  abort() {
    // Reject the promise returned from the upload() method.
    //server.abortUpload();
    this.cancelTokenSource.cancel("取消上传");
  }
}

export function ImageUploadAdapterPlugin(editor: Editor) {
  _.set(
    editor.plugins.get("FileRepository"),
    "createUploadAdapter",
    (loader: UploadLoader) => {
      return new ImageUploadAdapter(loader);
    }
  );
}
